import React from "react";

interface Props {
  open: boolean;
  html: string;
  subject: string;
  onClose: () => void;
}

const EmailTemplatePreview = ({
  open,
  html,
  subject,
  onClose,
}: Props) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center">

      <div className="bg-white rounded-xl shadow-xl w-[1000px] max-h-[90vh] overflow-hidden">

        {/* Header */}

        <div className="flex justify-between items-center border-b px-6 py-4">

          <h2 className="text-xl font-bold">
            Email Preview
          </h2>

          <button
            onClick={onClose}
            className="text-2xl hover:text-red-600"
          >
            ×
          </button>

        </div>

        {/* Body */}

        <div className="p-6 overflow-y-auto max-h-[calc(90vh-80px)]">

          {/* Subject */}

          <div className="mb-6">

            <label className="block font-semibold mb-2">
              Subject
            </label>

            <div className="border rounded-lg bg-gray-50 px-4 py-3">
              {subject}
            </div>

          </div>

          {/* Preview */}

          <div>

            <label className="block font-semibold mb-2">
              Email Preview
            </label>

            <div
              className="border rounded-lg bg-white p-6 min-h-[350px]"
              dangerouslySetInnerHTML={{
                __html: html,
              }}
            />

          </div>

        </div>

      </div>

    </div>
  );
};

export default EmailTemplatePreview;